import React, { useCallback } from 'react';
import clsx from 'clsx';
import {
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  SwipeableDrawer,
} from '@material-ui/core';
import { MobileDrawerProps } from './type';
import { UserMobileIcon, BoxMobileIcon } from 'asset/images';
import TimelineIcon from '@material-ui/icons/Timeline';

import { useModal, useUser } from 'hooks';
import { LibraryList } from 'components/Library';
import { Auth, AUTHORITIES } from 'commons/constants/KeyFlowConstants';
import Statistics from 'components/Statistics/Statistics';

const useStyles = makeStyles({
  drawer: {},
  list: {
    padding: '46px 0 0 0',
    width: 250,
    color: '#ffffff',
    fontSize: '1.4em',
  },
  fullList: {
    width: 'auto',
  },
  listItem: {
    borderBottom: '1px solid #b6b6b6',
    justifyContent: 'flex-end',
    '&:first-child': {
      borderTop: '1px solid #b6b6b6',
    },
    '& > div': {
      display: 'flex',
    },
  },
  icon: {
    width: '1rem',
    height: '1rem',
    margin: '0 10px 0 0',
  },
});

export default function MobileDrawer({ open, onClose, onOpen }: MobileDrawerProps) {
  const classes = useStyles();
  const { onLogout: onLogoutUser } = useUser();
  const { onOpenModal } = useModal();

  /***
   * 2021. 10. 27
   * 로그인 로직을 토큰 방식으로 변경함에따라 (기존 : 권한 API에서 가져옴)
   * 로컬 스토리지에 유저 정보 저장, 유저정보 가져오는 방식을 리덕스->로컬스토리지 로 변경
   */
  // const {userId} = useSelector((state: RootState) => state.user);
  const userId = localStorage.getItem(Auth.USER_ID);
  const authorities = localStorage.getItem(Auth.AUTHORITIES) || '';
  const hasAuth = authorities.includes(AUTHORITIES.STATISTICS_VIEW);

  const onLogout = useCallback(
    event => {
      onLogoutUser();
    },
    [onLogoutUser],
  );

  const onOpenLibrary = useCallback(() => {
    onOpenModal(<LibraryList />);
  }, [LibraryList, onOpenModal]);

  const onOpenStatistics = useCallback(() => {
    onOpenModal(<Statistics />);
  }, [Statistics, onOpenModal]);

  return (
    <SwipeableDrawer
      anchor="right"
      disableSwipeToOpen
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      PaperProps={{
        style: { backgroundColor: '#000817' },
      }}
    >
      <div className={clsx(classes.list)} onClick={onClose} onKeyDown={onClose}>
        <List>
          {hasAuth && (
            <ListItem button className={clsx(classes.listItem)} onClick={onOpenStatistics}>
              <TimelineIcon fontSize="medium" className={clsx(classes.icon)} />
              <p>통계</p>
            </ListItem>
          )}
          <ListItem button className={clsx(classes.listItem)}>
            <img src={UserMobileIcon} className={classes.icon} />
            <p>{userId} 님</p>
          </ListItem>
          <ListItem button className={clsx(classes.listItem)} onClick={onOpenLibrary}>
            <img src={BoxMobileIcon} className={classes.icon} />
            <p>보관함</p>
          </ListItem>
          <ListItem button className={clsx(classes.listItem)} onClick={onLogout}>
            <p>로그아웃</p>
          </ListItem>
        </List>
      </div>
    </SwipeableDrawer>
  );
}
